// extracted by mini-css-extract-plugin
export default {"outer":"Listing_outer__ThSqX","cardFlex":"Listing_cardFlex__KZyBZ"};